import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormControl} from '@angular/forms';
import {debounceTime, distinctUntilChanged} from 'rxjs';

@Component({
    selector: 'app-input-filed',
    templateUrl: './input-filed.component.html',
    styleUrls: ['./input-filed.component.scss'],
    standalone: false
})

export class InputFiledComponent implements OnInit {
  @Input() label         : string;
  @Input() labelClass    : string;
  @Input() placeholder   : string;
  @Input() value         : string;
  @Input() type          : string;
  @Input() class         : string;
  @Input() minlength     : string;
  @Input() maxDate       : string;
  @Input() maxlength     : number | string;
  @Input() maxDigits     : number;
  @Input() max           : number;
  @Input() min           : number;
  @Input() pattern       : any;
  @Input() starIcon      : any;
  @Input() control       : FormControl;
  @Input() toUpperCase   : boolean;
  @Input() readonly      : boolean;
  @Input() allowedType   : string;
  @Input() autocomplete  : string;
  @Input() borderColor   : boolean = false;
  @Output() inputEvent   : EventEmitter<any> = new EventEmitter<any>();

  constructor() {
    this.control = new FormControl('');
  }

  onChange(event: any) {
    if (this.maxDigits) {
      let controlValue = this.allowedType === 'number' ? String(this.control.value) : this.control.value;
      let digits = controlValue?.replace(/\D/g, '');
      if (digits?.length > this.maxDigits) {
        digits = digits.slice(0, this.maxDigits);
        this.control.setValue(this.allowedType === 'number' ? Number(digits) : digits);
      }
    }
  }

  onKeyDown(event: KeyboardEvent, val: any) {
    switch (this.allowedType) {
      case 'chars':
        this.handleCharsInput(event);
        break;
      case 'number':
        this.handleNumberInput(event);
        break;
      case 'date':
        this.handleDateInput(event);
        break;
    }
  }

  handleCharsInput(event: KeyboardEvent) {
    const key = event.key;
    const specialCharacterAndNumberRegex = /[!@#$%^&*()+{}[\]:;<>,.?~\\/\d-]/;
    if (specialCharacterAndNumberRegex.test(key)) {
      event.preventDefault();
    }
  }

  handleNumberInput(event: KeyboardEvent) {
    if (event.ctrlKey || event.metaKey) {
      return;
    }
    const allowedKeys = ['Backspace','Tab'];
    if (allowedKeys.includes(event.key)) return;
    const regex = /\d/;
    if (!regex.test(event.key)) {
      event.preventDefault();
    }
  }

  handleDateInput(event: KeyboardEvent) {
    const key = event.key;
    const allowedRegex = /^[0-9/]$/;
    const allowedControlKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab'];
    if (allowedControlKeys.includes(key)) return;
    if (!allowedRegex.test(key)) {
      event.preventDefault();
    }
  }

  ngOnInit(): void {
    this.control?.valueChanges.pipe(debounceTime(500))
      .pipe(distinctUntilChanged()).subscribe((res: any) => {
        if (this.control.value) {
          const trimmedValue = String(this.control.value || '');
          const processedValue = this.toUpperCase ? trimmedValue?.replace(/\s+/g, ' ')?.toUpperCase() : trimmedValue?.replace(/\s+/g, ' ');
          const finalValue = processedValue.replace(/^\s+/, '');
          this.control.setValue(this.allowedType === 'number' ? Number(finalValue) : finalValue, { emitEvent: false });
        }
      })
  }

  getInputValue(event: any){
    this.inputEvent.emit(event);
  }

  onPaste(event: ClipboardEvent) {
    if (this.allowedType !== 'number') {
      return;
    }
    event.preventDefault();
    const pastedText = event.clipboardData?.getData('text') || '';
    let digitsOnly = pastedText.replace(/\D/g, '');
    let limit: number | null = null;
    const maxDigits = this.maxDigits ? Number(this.maxDigits) : null;
    const maxLength = this.maxlength ? Number(this.maxlength) : null;
    if (maxDigits !== null && maxLength !== null) {
      limit = Math.min(maxDigits, maxLength);
    } else if (maxDigits !== null) {
      limit = maxDigits;
    } else if (maxLength !== null) {
      limit = maxLength;
    }
    if (limit !== null) {
      digitsOnly = digitsOnly.slice(0, limit);
    }
    this.control.setValue(Number(digitsOnly));
  }

}
